// extracted by mini-css-extract-plugin
export default {"text":"NavigationButton_text__KATZa","root":"NavigationButton_root__2uDMZ"};